<script setup lang="ts">
import {postApi} from "~/utils/RequestUtil";

definePageMeta({
  middleware: ['auth']
})

useHead({
  title: '患者列表'
})

const authUser = useState('authUser')

const activePatientDesign = useState('activePatientDesign', () => null)
const activePatientDesignList = useState('activePatientDesignList', () => [])

const router = useRouter()
const toast = useToast()
const value = ref('')

const dateSearchType = ref('创建时间')
const dateSearchTypeOptions = ['保存时间', '确认时间', '创建时间']
const searchStartDate = ref()
const searchEndDate = ref()

const countries = ['患者姓名', '医生姓名']
const columns = [
  {
    key: 'select',
    label: ''
  },
  {
    key: 'patientName',
    label: '患者 / 出生日期',
    sortable: false
  },
  {
    key: 'designName',
    label: '设计',
    sortable: false
  },
  {
    key: 'saveAt',
    label: '保存时间',
    sortable: true
  },
  {
    key: 'lensOrder.createAt',
    label: '参数确认时间',
    sortable: true
  },
  {
    key: 'createAt',
    label: '医生 / 创建时间',
    sortable: true,
  },
  {
    key: 'remarks',
    label: '备注',
    sortable: false
  },
  {
    key: 'action',
    label: '操作'
  }
]

const patientDesignList = ref([])

const patientDesignListLoading = ref(true)

const onlyCurrentPatient = ref(false)
const onlyHasOrderPatient = ref(false)

watch(() => onlyCurrentPatient.value, (newVal) => {
  getPatientDesignList()
})

watch(() => onlyHasOrderPatient.value, (newVal) => {
  getPatientDesignList()
})

const onlyCurrentPatientName = computed(() => {
  if(selectedPatientDesign.value && onlyCurrentPatient.value) {
    return selectedPatientDesign.value?.patient?.patientName
  } else {
    return null
  }
})

const getPatientDesignList = () => {
  patientDesignListLoading.value = true
  postApi('/patientDesign/getPatientDesignList', {
		searchType: country.value,
	  searchValue: value.value,
    patientNameOnly: onlyCurrentPatientName.value,
	  hasOrderOnly: onlyHasOrderPatient.value,
	  searchDateType: dateSearchType.value,
	  searchStartDate: searchStartDate.value,
	  searchEndDate: searchEndDate.value,
  }).then((res) => {
    patientDesignListLoading.value = false
    if (res.code === 0) {
      patientDesignList.value = res.data.patientDesignList
    } else {
      toast.add({
        title: res.msg || '获取列表失败，请稍后重试',
        color: 'red'
      })
    }
  }).catch(() => {
    patientDesignListLoading.value = false
    toast.add({
      title: '发送请求失败，请检查网络或稍后重试！',
      color: 'red'
    })
  })
}

onMounted(() => {
  getPatientDesignList()
})

onActivated(() => {
  getPatientDesignList()
})

const country = ref(countries[0])

const toInfo = ({hum}: { hum: any }) => {
  if (hum == '查看') {
    if (activePatientDesign.value == null) {
      toast.add({
        title: '请选择要查看的信息！',
        color: 'red'
      })
    } else {
      // router.push(`/creatInfrom?id=${selected.value[0]?.id}&name=查看&patientName=${selected.value[0]?.patientName}`)
      router.push(`/patientDesign/${activePatientDesign.value?.id}/patient?action=view`)
    }
  }
  if (hum == '调参') {
    if (activePatientDesign.value == null) {
      toast.add({
        title: '请选择要调参的信息！',
        color: 'red'
      })
    } else {
	    handlerEditParam(activePatientDesign.value)

      // router.push(`/patientDesign/${activePatientDesign.value?.id}/lensDesign`)
    }

  }
  if (hum == '新建设计') {
    router.push(`/patientDesign/new/patient?copyBy=${activePatientDesign.value?.id}`)
    activePatientDesign.value = null
  }
  if (hum == '新建患者') {
    router.push(`/patientDesign/new/patient`)
    activePatientDesign.value = null
  }
}

const selectedPatientDesign = ref(null)
const selectedPatientDesignList: any = ref([])

const enabledMultiSelect = ref(false)

onMounted(() => {
	selectedPatientDesign.value = activePatientDesign.value
  selectedPatientDesignList.value = activePatientDesignList.value
})

onActivated(() => {
	selectedPatientDesign.value = activePatientDesign.value
  selectedPatientDesignList.value = activePatientDesignList.value
})

const tableActionLock = ref(false)
const tableClearSelectFlag = ref(false)

let oldEnabledMultiSelect = enabledMultiSelect.value

watch(
    [() => enabledMultiSelect.value, () => patientDesignList.value],
    ([newEnabled, newList], [oldEnabled, oldList]) => {
      selectedPatientDesignList.value = patientDesignList.value.map(item => item.id)

      // 判断 enabledMultiSelect 从 false 变成 true
      if (!oldEnabled && newEnabled) {
        // selectedPatientDesign.value = null
      }

      // 更新旧值
      oldEnabledMultiSelect = newEnabled

      if(!newEnabled) {
        selectedPatientDesignList.value = []
      }
    },
    { immediate: true }
)

// watch(() => enabledMultiSelect.value, (newVal) => {
//   selectedPatientDesignList.value = patientDesignList.value.map((item) => {
//     return item.id
//   })
//   selectedPatientDesign.value = null
// })

const handlerTableSelect = (row) => {
  console.log('【复选框触发】')

  if(enabledMultiSelect.value) {
    // 多选模式
    if(tableClearSelectFlag.value) {
      // selectedPatientDesign.value = null
    } else {
      if(selectedPatientDesignList.value.includes(row.id)) {
        if (!tableActionLock.value) {
          selectedPatientDesignList.value.splice(selectedPatientDesignList.value.indexOf(row.id), 1)
        }
      } else {
        selectedPatientDesignList.value.push(row.id)
      }
      // if (selectedPatientDesign.value?.id === row.id) {
      //   if (!tableActionLock.value) {
      //     selectedPatientDesign.value = null
      //   }
      // } else {
      //   selectedPatientDesign.value = row
      // }
    }
  } else {
    // 单选模式
    if(tableClearSelectFlag.value) {
      // selectedPatientDesign.value = null
    } else {
      if (selectedPatientDesign.value?.id === row.id) {
        if (!tableActionLock.value) {
          selectedPatientDesign.value = null
        }
      } else {
        selectedPatientDesign.value = row
      }
    }
  }
}

watch(() => selectedPatientDesign.value, (value) => {
  if (value === null) {
    activePatientDesign.value = null
    console.log('【当前激活项变更】')
    console.log(activePatientDesign.value)
  } else {
    activePatientDesign.value = selectedPatientDesign.value
    console.log('【当前激活项变更】')
    console.log(activePatientDesign.value)
  }
})

watch(() => selectedPatientDesignList.value, (value) => {
  if (value === null) {
    activePatientDesignList.value = []
  } else {
    activePatientDesignList.value = selectedPatientDesignList.value
  }
})

function toInfos1(num1, hum, num2, row = null) {
  console.log('【按钮触发】')

  if (hum == '查看') {
    tableActionLock.value = true
    tableClearSelectFlag.value = false
    router.push(`/patientDesign/${num1}/patient?action=view`)
    // router.push(`/creatInfrom?id=${num1}&name=查看&patientName=${num2}`)
  }
  if (hum == '调参') {
    tableActionLock.value = true
    tableClearSelectFlag.value = false

	  handlerEditParam(row)

    // router.push(`/patientDesign/${num1}/lensDesign`)
    // router.push(`/creatInfrom?id=${num1}&name=调参&patientName=${num2}`)
  }
  if (hum == '新建设计') {
    tableActionLock.value = false
    tableClearSelectFlag.value = true
    // alert('正在维护中，暂不支持此功能')
    // router.push(`/patient/new`)
    // router.push(`/creatInfrom?&name=新建设计&patientName=${num2}`)
    router.push(`/patientDesign/new/patient?copyBy=${num1}`)
  }

	if (hum == '删除') {
		tableActionLock.value = false
		tableClearSelectFlag.value = true
		if(confirm('您确定要删除此设计吗？')) {
			console.log('确认删除')
			postApi('/patientDesign/deletePatientDesign', {
				patientDesignId: num1
			}).then((res) => {
				if(res.code === 0) {
					toast.add({
						title: '设计删除成功'
					})

					activePatientDesign.value = null
					getPatientDesignList()
				} else {
					toast.add({
						title: `删除失败：${res.msg || '请稍后重试'}`,
						color: 'red',
						timeout: 6000
					})
				}
			}).catch((e) => {
				toast.add({
					title: `发起请求失败，请检查网络或稍后重试！`,
					color: 'red',
					timeout: 6000
				})
			})
		} else {
			console.log('取消删除')
		}
		// router.push(`/patientDesign/new/patient?copyBy=${num1}`)
	}

  setTimeout(() => {
    tableActionLock.value = false
    tableClearSelectFlag.value = false
  }, 300)
}

const copyDesignDialogOpen = ref(false)
const copyDesignData = ref(null)

const handlerEditParam = (_patientDesign: any) => {
	console.log('[处理调参]')
	console.log(_patientDesign)

	if(_patientDesign.lensOrder) {
		// 已下单
		copyDesignData.value = _patientDesign
		copyDesignDialogOpen.value = true
	} else {
		// 未下单
		copyDesignData.value = null
		copyDesignDialogOpen.value = false
		router.push(`/patientDesign/${_patientDesign?.id}/lensDesign`)
	}
}

const copyDesignLoading = ref(false)

const handlerCopyDesign = () => {
	copyDesignLoading.value = true

	postApi('/patientDesign/copyPatientDesign', {
		patientDesignId: copyDesignData.value?.id
	}).then((res) => {
		console.log('[复用结果]')
		console.log(res)
		if(res.code === 0) {
			toast.add({
				title: '复用成功，请在列表中查看新设计'
			})

			getPatientDesignList()

			copyDesignDialogOpen.value = false
		} else {
			toast.add({
				title: `复用失败：${res.msg}`,
				color: 'red'
			})
		}
	}).catch((e) => {
		console.log('[复用异常]')
		console.log(e)
		toast.add({
			title: `发起请求失败，请检查网络或稍后重试`,
			color: 'red'
		})
	}).finally(() => {
		copyDesignLoading.value = false
	})
}
</script>
<template>
	<UDashboardModal
		v-model="copyDesignDialogOpen"
		title="复用数据创建新设计"
		description="当前设计已确认，无法进行修改，是否复用数据再创建一个新设计？"
		icon="i-heroicons-square-2-stack"
		:ui="{
      icon: { base: 'text-blue-500 dark:text-blue-400' } as any,
      footer: { base: 'ml-16' } as any
    }"
	>
		<template #footer>
			<div class="flex w-full justify-end items-center gap-4">
				<UButton color="white" label="取消" @click="copyDesignDialogOpen = false" />
				<UButton color="blue" label="复用并创建新设计" :loading="copyDesignLoading" @click="handlerCopyDesign" />
			</div>
		</template>
	</UDashboardModal>

  <div class="flex flex-col relative w-full h-full">
    <UDashboardNavbar class="bg-primary">
      <template #right>
        <div class="flex-1 flex-shrink-0 w-full p-2 bg-white/90 rounded-md">
          <img src="@/public/icomfit_logo.png" alt="" class="h-6 object-contain">
        </div>
      </template>
      <template #title>
        <div class="flex items-center gap-2 text-gray-100">
          <div>
            患者列表
          </div>
          <div v-if="authUser?.hospital?.hospitalName" class="text-xs text-gray-100">
            {{ authUser?.hospital?.hospitalName }}
          </div>
        </div>
      </template>
    </UDashboardNavbar>

    <div class="mt-4 px-4 flex justify-between items-center gap-2">
      <div class="flex gap-2">
        <USelectMenu v-model="country" :options="countries"/>
        <UInput v-if="onlyCurrentPatient && country === '患者姓名'" disabled :model-value="selectedPatientDesign?.patient?.patientName" placeholder="请输入..." @keydown.enter="getPatientDesignList"/>
        <UInput v-else v-model="value" placeholder="请输入..." @keydown.enter="getPatientDesignList"/>
	      <USelectMenu v-model="dateSearchType" :options="dateSearchTypeOptions"/>
        <UInput v-model="searchStartDate" type="date" placeholder="开始日期" @keydown.enter="getPatientDesignList"/>
	      <div class="flex justify-center items-center">
		      ~
	      </div>
        <UInput v-model="searchEndDate" type="date" placeholder="结束日期" @keydown.enter="getPatientDesignList"/>
        <UButton @click="getPatientDesignList">查询 / 刷新</UButton>
      </div>
      <div class="flex gap-2 items-center">
        <transition name="fade">
          <div v-if="selectedPatientDesign">
            <UCheckbox
                label="仅查看该患者的设计"
                v-model="onlyCurrentPatient"
            />
          </div>
        </transition>
	      <div>
		      <UCheckbox
			      label="仅查看已确认的设计"
			      v-model="onlyHasOrderPatient"
		      />
	      </div>
      </div>
    </div>
    <div class="w-[100%] mt-4 flex-1 overflow-y-hidden">
      <UTable
          :loading="patientDesignListLoading"
          :rows="patientDesignList"
          :columns="columns"
          :ui="{thead: 'sticky top-0 bg-[rgba(255,255,255,0.8)] backdrop-blur z-10', tr: { base: 'hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer'}, th: {base: '!hover:translate'}}"
          class="h-full"
          @select="handlerTableSelect"
      >
        <template #select-data="{ row }">
          <div v-if="enabledMultiSelect">
            <UCheckbox :model-value="selectedPatientDesignList.includes(row.id)"/>
          </div>
          <div v-else>
            <UCheckbox :model-value="selectedPatientDesign?.id === row.id"/>
          </div>
        </template>

        <template #patientName-data="{row}">
          <div class="flex flex-col gap-1">
            <div>
              {{ row.patient?.patientName }}
            </div>
            <div class="text-xs text-gray-500">
              {{ formatDate(row.patient?.patientBirthday, 'Y-m-d') || '&nbsp;' }}
            </div>
          </div>
        </template>

        <template #designName-data="{row}">
          <div class="flex flex-col gap-1">
            <div>
              {{ row.designName }}
            </div>
            <div v-if="row.patientEye?.eyeODStatus === 'HasMxfData' || row.patientEye?.eyeOSStatus === 'HasMxfData'" class="flex gap-1">
              <UKbd v-if="row.patientEye?.eyeODStatus === 'HasMxfData'">OD</UKbd>
              <UKbd v-if="row.patientEye?.eyeOSStatus === 'HasMxfData'">OS</UKbd>
            </div>
            <div v-else class="flex gap-1">
              &nbsp;
            </div>
          </div>
        </template>

        <template #saveAt-data="{row}">
          <div class="flex flex-col gap-1">
            <div v-if="row.saveUser">
              {{ row.saveUser?.profile?.name || '- -' }}
            </div>
            <div v-if="row.saveAt">
              {{ formatDate(row.saveAt, '人性化') }}
            </div>
            <div v-else>
              - -
            </div>
          </div>
        </template>

        <template #lensOrder.createAt-data="{row}">
            <div class="flex flex-col gap-1 w-24">
	            <div v-if="row.lensOrder">
		            <div>
			            {{ formatDate(row.lensOrder?.createAt, '人性化') }}
		            </div>
	            </div>
	            <div v-else>
		            <div>
			            - -
		            </div>
		            <div>
			            - -
		            </div>
	            </div>
            </div>
        </template>
        <template #createAt-data="{row}">
          <div class="flex flex-col gap-1">
            <div class="flex flex-col">
	            <div>
		            <UTooltip :text="row.user?.username" :popper="{placement: 'right'}">
		              {{ row.user?.profile?.name || '- -' }}
		            </UTooltip>
	            </div>
	            <div v-if="false">
		            ( {{ row.user?.username }} )
	            </div>
            </div>
            <div>
              {{ formatDate(row.createAt, '人性化') }}
            </div>
          </div>
        </template>

        <template #remarks-data="{row}">
          <div v-if="row.designDescription && row.designDescription.trim() !== ''" class="text-xs w-24 line-clamp-2 text-wrap">
            {{ row.designDescription }}
          </div>
          <div v-else>
            - -
          </div>
        </template>

        <template #action-data="{ row }">
          <div class="flex gap-2">
            <div class="relative flex flex-row gap-2">
              <div v-if="enabledMultiSelect" class="absolute top-0 left-0 right-0 bottom-0 z-30 bg-white/80">
                <div class="w-full h-full flex justify-center items-center select-none">
                  多选模式下禁止操作
                </div>
              </div>
              <UButton
                  variant="soft"
                  :disabled="enabledMultiSelect"
                  @click="toInfos1(row.id,'查看',row.patientName)"
              >
                查看
              </UButton>
              <UButton
                  variant="soft"
                  :disabled="enabledMultiSelect"
                  @click="toInfos1(row.id,'调参',row.patientName, row)"
              >
                调参
              </UButton>

              <UButton
                  variant="soft"
                  :disabled="enabledMultiSelect"
                  @click="toInfos1(row.id,'新建设计',row.patientName)"
              >
                新建设计
              </UButton>

              <UButton
                  variant="soft"
                  color="red"
                  :disabled="enabledMultiSelect"
                  @click="toInfos1(row.id,'删除',row.patientName)"
              >
                删除
              </UButton>
            </div>
          </div>
        </template>
      </UTable>
    </div>


    <div class="">
      <div class="h-[1px] flex-shrink-0 bg-gray-200">
        <!-- 分界线 -->
      </div>
      <div class="h-16 flex-shrink-0 px-4 flex justify-center items-center gap-2 relative">
        <div class="absolute left-4 top-0 bottom-0 flex gap-2 justify-center items-center">
          <UCheckbox :label="'全选' + (selectedPatientDesignList.length > 0?` (${selectedPatientDesignList.length})`:'')" v-model="enabledMultiSelect" />
          <UTooltip text="多选模式下，只能进行批量导出操作" :popper="{ arrow: true }">
            <div class="flex items-center p-2 rounded-md hover:bg-gray-100">
              <UIcon name="i-heroicons-exclamation-circle-16-solid"></UIcon>
            </div>
          </UTooltip>
        </div>

        <div class="relative flex gap-2">
          <div v-if="enabledMultiSelect" class="absolute top-0 left-0 right-0 bottom-0 z-30 bg-white/80">
            <div class="w-full h-full flex justify-center items-center select-none">
              多选模式下禁止操作
            </div>
          </div>
          <UButton variant="solid" :disabled="enabledMultiSelect || !selectedPatientDesign" @click="toInfo({hum : '查看'})">查看</UButton>
          <UButton variant="solid" :disabled="enabledMultiSelect || !selectedPatientDesign" @click="toInfo({hum : '调参'})">调参</UButton>
          <UButton variant="solid" :disabled="enabledMultiSelect" @click="toInfo({hum : '新建患者'})">新建患者</UButton>
          <UButton variant="solid" :disabled="enabledMultiSelect || !selectedPatientDesign" @click="toInfo({hum : '新建设计'})">新建设计</UButton>
        </div>


      </div>
    </div>
  </div>
</template>
<style>

</style>
